import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  INavData,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective
} from '@coreui/angular';

import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems, TranslatableNavData } from './_nav';
import { AppService } from '../../app.service';
import { ApiUrl } from '../../../assets/constants';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    CommonModule,
    HttpClientModule,
    TranslateModule
  ]
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public navItems: INavData[] = navItems;
  public referralCode: string = '';
  public copyTooltip: string = '';
  private langSub: Subscription;

  constructor(private appService: AppService, private translate: TranslateService) {
    this.translateNav();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.translateNav();
    });
  }

  ngOnInit() {
    this.appService.getApi(ApiUrl.STORAGEAPI + '/referral/code').subscribe(
      (res: any) => {
        this.referralCode = res?.referral_code || '';
      },
      (err: any) => {
        console.log('Referral code fetch error:', err);
      }
    );
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  private translateNav() {
    this.navItems = navItems.map(item => this.translateItem(item));
  }

  private translateItem(item: TranslatableNavData): INavData {
    const translated: INavData = { ...item };
    if (item.nameKey) {
      translated.name = this.translate.instant(item.nameKey);
    }
    if (item.children) {
      translated.children = item.children.map(child => this.translateItem(child));
    }
    return translated;
  }

  copyReferralCode() {
    if (this.referralCode) {
      navigator.clipboard.writeText(this.referralCode).then(() => {
        this.copyTooltip = 'Copied!';
        setTimeout(() => { this.copyTooltip = ''; }, 2000);
      });
    }
  }

  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }
}
